export default "__VITE_ASSET__BzBG7pYL__"